import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { DataTable } from "../data-table/data-table";

export function DashboardLogs() {

    const [logs, setLogs] = useState<any[]>([]);

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const response = await api.get('/logs');

                if (response.status !== 200) {
                    throw new Error('Network response was not ok');
                }

                setLogs(response.data);
            } catch (error) {
                console.error('Error fetching logs:', error);
            }
        }

        fetchLogs();
    }, []);

    const columns: ColumnDef<any>[] = [
        {
            accessorKey: 'timestamp',
            header: 'Zeitstempel',
            cell: ({ row }) => (
                <span>{new Date(row.getValue('timestamp')).toLocaleString()}</span>
            )
        },
        {
            accessorKey: 'message',
            header: 'Nachricht',
        },
        {
            accessorKey: 'success',
            header: 'Erfolgreich',
            cell: ({ row }) => (
                <span className={row.getValue('success') ? '' : 'danger-cell'}>{row.getValue('success') ? 'Ja' : 'Nein'}</span>
            )
        }
    ];

    if (!logs || logs.length === 0) {
        return (
            <div className="dashboard-logs">
                <p>Es wurden noch keine Logs gefunden.</p>
            </div>
        );
    }

    return (
        <div className="dashboard-logs">
            <h4>Dashboard Logs ({logs.length})</h4>
            <DataTable
                columns={columns}
                data={logs}
            />
        </div>
    );
}